<template>
  <v-card width="320" title="GIS" prepend-icon="layers">
    <v-list>
      <v-list-group v-for="gisMapFeature in gisMapFeatures" :key="gisMapFeature.layerKey">
        <template #activator="{ props: itemProps }">
          <v-list-item v-bind="itemProps" :title="gisMapFeature.layerKey" />
        </template>

        <template #default>
          <div v-for="(feature, index) of gisMapFeature.features" :key="index">
            <v-list-item
              v-for="[propertyKey, propertyValue] of Object.entries(feature).filter(([_key, value]) => !!value)"
              :key="propertyKey"
              :title="startCase(propertyKey)"
              :subtitle="propertyValue ? String(propertyValue) : undefined"
            />
            <v-divider />
          </div>
        </template>
      </v-list-group>
    </v-list>
  </v-card>
</template>

<script setup lang="ts">
import startCase from "lodash-es/startCase"

const { gisMapFeatures } = defineProps<{ gisMapFeatures: Array<MapFeatureData> }>()
</script>
